import { ToastData, type IToastData } from '@/objects/ToastData';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useToastStore = defineStore('toast', () => {
    let idhelper = 1;
    const toasts = ref<Array<ToastData>>([]);

    const remove = (toast: ToastData) => {
        const index = toasts.value.indexOf(toast);
        if (index != undefined && index > -1) {
            toasts.value.splice(index, 1);
        }
    };

    const add = (toast: IToastData) => {
        idhelper++;
        toasts.value.push(new ToastData(toast, idhelper));
    };

    const addInfo = (message: string, params?: any) => add({ message, level: 'INFO', params });
    const addWarning = (message: string, params?: any) => add({ message, level: 'WARNING', params });
    const addError = (message: string, title?: string, params?: any) => add({ message, level: 'ERROR', title, params });
    const addSuccess = (message: string, params?: any) => add({ message, level: 'SUCCESS', params });

    // Add the initial message if it exists

    return {
        toasts,
        remove,
        add,
        addInfo,
        addWarning,
        addError,
        addSuccess,
    };
});
